<template lang="pug">
  v-flex.beneficiarios.mt-3(xs12 sm12 md12 lg12)
      //-- MODAL INICIAL
      //- v-dialog(v-model="modalInit" width="363" persistent)
        v-card
          .modal.modal-recuerda.modal-one-btn.mx-auto
            figure.text-xs-center
              img(src="../assets/beneficiarios/img-recuerda.png")
            h2.font-weight-medium.text-blue.text-xs-center ¡Recuerda!
            p.mx-auto
              | Si no encuentras el parentesco en el listado de beneficiarios, por favor ponte en contacto con nuestro equipo de atención al cliente desde nuestro
              strong.g-font-medium
                a(href="links.Chat" target="_blank") chat web.
            button(@click="modalInit = false").g-font-semibold Entendido
      //-- MODAL INICIAL
      v-dialog(v-model="modalValidacion" width="363" persistent)
        v-card
          .modal.modal-recuerda.modal-one-btn.mx-auto
            figure.text-xs-center
              img(src="../assets/beneficiarios/img-delete.png")
            //- h2.font-weight-medium.text-blue.text-xs-center Ten en cuenta
            p.mx-auto {{ textValidation }}
            button(@click="modalValidacion = false").g-font-semibold Entendido
      //-- MODAL PARA ELIMINAR UN BENEF
      v-dialog(v-model="modalDelete" width="363" persistent)
        v-card
          .modal.modal-delete.modal-two-btn.mx-auto
            figure.text-xs-center
              img(src="../assets/beneficiarios/img-delete.png")
            h2.font-weight-medium.text-blue.text-xs-center ¿Estás seguro que quieres eliminar a tu beneficiario?
            .btns.mx-auto
              button(@click="closeModalDelete").g-font-semibold Cancelar
              button(@click="deleteBenefit").g-font-semibold Eliminar
      //-- MODAL ERROR CODE
      v-dialog(v-model="modalErrorCode" width="363" persistent)
        v-card
          .modal.modal-delete.modal-one-btn.mx-auto
            figure.text-xs-center
              img(src="../assets/beneficiarios/img-oops.png")
            h2.font-weight-medium.text-blue.text-xs-center ¡El código ingresado es incorrecto!
            p.mx-auto
              | Vuelve a intentarlo.
            button(@click="modalErrorCode = false").g-font-semibold Entendido
      //-- MODAL PARA AGREGAR UN BENEF
      v-dialog(v-model="modalSave" width="363" persistent)
        v-card
          .modal.modal-save.modal-one-btn.mx-auto
            figure.text-xs-center
              img(src="@/assets/characters/informa.svg")
            h2.font-weight-medium.mx-auto.text-blue.text-xs-center ¡Datos Guardados!
            p.mx-auto Puedes continuar agregando beneficiarios o finalizar la solicitud.
            button(@click="saveBenefit").g-font-semibold Entendido
      //-- MODAL PARA PROCEDER LA SOLICITUD
      v-dialog(v-model="modalProcede" width="363")
        v-card
          .modal.modal-procede.modal-one-btn.mx-auto
            figure.text-xs-center
              img(src="@/assets/characters/informa.svg")
            h2.font-weight-medium.mx-auto.text-blue.text-xs-center ¿Estás seguro que quieres proceder con tu solicitud?
            p.mx-auto Recuerda que no podrás modificar tus beneficiarios hasta que la solicitud sea aprobada dentro de 24hr.
            button(@click="goToStep3()").g-font-semibold Entendido
      //-- MODAL-TOOLTIP % DE DISTRIBUCION
      v-dialog(v-model="tooltips.distribution" width="455")
        v-card
          .modal.modal-tooltip.modal-one-btn.mx-auto
            p.mx-auto La sumatoria total del porcentaje asignado para tus beneficiarios tiene que ser del 100%.
            button(@click="tooltips.distribution = false").g-font-semibold ACEPTAR
      //-- MODAL-TOOLTIP BENEFICIARIO PRINCIPAL
      v-dialog(v-model="tooltips.mainBenef" width="455")
        v-card
          .modal.modal-tooltip.modal-one-btn.mx-auto
            p.mx-auto Los beneficiarios principales son las personas designadas para recibir el beneficio del seguro, en caso de fallecimiento del asegurado durante la vigencia de la póliza.
            button(@click="tooltips.mainBenef = false").g-font-semibold ACEPTAR
      //-- MODAL-TOOLTIP BENEFICIARIO CONTINGENTE
      v-dialog(v-model="tooltips.secondaryBenef" width="455")
        v-card
          .modal.modal-tooltip.modal-one-btn.mx-auto
            p.mx-auto El beneficiario contingente  es la persona o personas designadas para recibir el beneficio del seguro, en caso que el asegurado y él o los beneficiarios principales fallezcan durante la vigencia de la póliza.
            button(@click="tooltips.secondaryBenef = false").g-font-semibold ACEPTAR
      //-- DECLARACION JURADA
      v-dialog(v-model="tooltips.declaracion" width="363")
        v-card
          .modal.modal-procede.modal-one-btn.mx-auto
            span(@click="tooltips.declaracion = false").g-font-semibold.close-modal-custom.text-blue x
            h2.font-weight-medium.mx-auto.text-blue.text-xs-center Declaración Jurada
            p.mx-auto(style="font-size:16px;line-height:1.2;text-align:justify") "Yo, en mi calidad de Contratante de la presente póliza, doy fe de que la información registrada en mi solicitud de designación/modificación de beneficiario(s) es verídica y entiendo que, en caso de haber faltado a la verdad, esta solicitud será declarada como no presentada y perderá validez para todos los efectos. En este supuesto, el(los) beneficiario(s) de mi póliza serán aquellos que declaré con anterioridad a la presente solicitud o, en caso de no haber efectuado declaración previa, serán mis herederos legales."
      //-- BODY DE TODA LA PÁGINA
      v-container(style="background-color:#fff; padding:2rem !important")
          .beneficiarios-steps-header(v-show="!stepFinish")
            v-layout
              .beneficiarios-steps-header-item(:class="{ 'circle-active': activeCircle1 }")
                .circle.circle-active.circle-line.transition-all-3
                  v-icon check
                strong Solicitud
              .beneficiarios-steps-header-item(:class="{ 'circle-active': activeCircle2 }")
                .circle.circle-line.transition-all-3
                  p(v-show="step2HeaderText") 2
                  v-icon(v-show="step2HeaderCheck") check
                strong Resumen
              .beneficiarios-steps-header-item(:class="{ 'circle-active': activeCircle3 }")
                .circle.transition-all-3
                  p(v-show="step3HeaderText") 3
                  v-icon(v-show="step3HeaderCheck") check
                strong Validación
          v-layout
              v-flex(:lg2="sizeWidth.large", :lg1="sizeWidth.medium", :lg4="(step3 || stepFinish) && (sizeWidth.medium || sizeWidth.large)")
              v-flex#product-detail(:lg4="sizeWidth.large", :lg5="sizeWidth.medium", v-show="(!step3 && !stepFinish) && (sizeWidth.medium || sizeWidth.large)")
                v-flex(md10 lg10)
                  v-layout
                    v-flex.myproduct
                      h2.omnesMedium.mp-title Mi Producto
                      v-layout.row-mp-subtitle
                        v-flex(lg10)
                          h4.omnesRegular.mp-subtitle Elige el tipo de solicitud que deseas registrar.
                        v-flex.col-mp-button(lg2)
                          button(@click="changeRequirement()") Editar
                      v-layout.row-mp-data.hr
                        v-flex.mp-data-name(lg4)
                          span Producto
                        v-flex.mp-data-value(lg8)
                          p {{ productName }}
                      v-layout.row-mp-data.hr
                        v-flex.mp-data-name(lg4)
                          span Póliza
                        v-flex.mp-data-value(lg8)
                          p {{ policy }}
                      v-layout.row-mp-data.hr.last
                        v-flex.mp-data-name(lg4)
                          span Tipo de solicitud
                        v-flex.mp-data-value(lg8)
                          p Modificación de Beneficiarios
              v-flex(:lg4="sizeWidth.large || (step3 && sizeWidth.medium)", :lg5="sizeWidth.medium")
                  .beneficiarios-content.mx-auto(:style="(step3 || stepFinish) ? 'border: 0' : ''")
                      .beneficiarios-step-1(v-show="step1")
                          .beneficiarios-step-1-title
                            h2.font-weight-medium.text-blue.text-xs-center Completa la información
                            p.mt-4 En esta solicitud puedes <strong>incluir, excluir y modificar</strong> los datos de tus beneficiarios.
                            p.mt-4
                              strong ¡Recuerda!
                              |  Si no encuentras el parentesco en el listado de beneficiarios, por favor comunícate&nbsp;
                              a(:href="links.WhatsApp" target="_blank" class="omnesMedium") aquí
                              | .
                          .beneficiarios-step-1-section
                              .g-flex.align-center
                                h2.font-weight-medium.text-blue.mr-2 Beneficiarios principales
                                svg(width='16' height='16' viewbox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' @click="showTooltip('mainBenef')")
                                  path(d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z' fill='#D0D6E0')
                                  path(d='M7.8557 9.55915C8.14494 9.55915 8.34801 9.47115 8.3714 9.28223C8.39663 8.38869 9.01324 8.025 9.62986 7.6213C9.98909 7.45188 10.2938 7.18534 10.5094 6.8518C10.7251 6.51826 10.8431 6.13104 10.8502 5.73392C10.8502 4.48838 9.85632 3.59484 8.22063 3.59484C7.47641 3.5623 6.74769 3.81422 6.18247 4.29946C5.99381 4.45927 5.83882 4.65501 5.72652 4.87529C5.61421 5.09557 5.54684 5.33598 5.52832 5.58253C5.52832 6.25946 6.39663 6.28715 6.40894 6.24961C6.43625 5.80183 6.63886 5.38284 6.97289 5.08337C7.30691 4.7839 7.74546 4.62806 8.19355 4.64961C9.0994 4.64961 9.61509 5.11484 9.61509 5.83238C9.61509 6.48654 9.06124 6.72592 8.49509 7.10315C8.13447 7.30345 7.83525 7.59823 7.62957 7.95581C7.42389 8.31339 7.31953 8.72026 7.3277 9.13269C7.31478 9.42069 7.54124 9.55915 7.8557 9.55915ZM7.79417 11.9745H7.97017C8.06258 11.9866 8.15654 11.9776 8.24495 11.9481C8.33336 11.9186 8.41391 11.8694 8.48053 11.8042C8.54714 11.739 8.59808 11.6595 8.62949 11.5718C8.6609 11.484 8.67197 11.3903 8.66186 11.2976V11.1468C8.67323 11.053 8.66315 10.9579 8.63238 10.8685C8.60161 10.7792 8.55095 10.698 8.48422 10.6311C8.41749 10.5642 8.33643 10.5133 8.24717 10.4823C8.15791 10.4513 8.06277 10.4409 7.96894 10.4521H7.79294C7.70049 10.4429 7.60716 10.4547 7.51986 10.4864C7.43255 10.5182 7.35349 10.5691 7.28851 10.6355C7.22353 10.7019 7.1743 10.782 7.14444 10.87C7.11459 10.958 7.10487 11.0515 7.11601 11.1438V11.2945C7.10499 11.3862 7.11488 11.4792 7.14495 11.5665C7.17503 11.6538 7.22449 11.7332 7.28964 11.7986C7.35479 11.8641 7.43392 11.9139 7.52109 11.9444C7.60826 11.9748 7.70121 11.9851 7.79294 11.9745H7.79417Z' fill='white')
                              p.mb-0.mt-1 Solo se puede agregar un máximo de 10 beneficiarios principales.
                              .beneficiarios-step-1-list
                                article(v-for="(itemBenefitPrincipal, indexBenefitPrincipal) in listBeneficiariosPrincipal", :key="indexBenefitPrincipal", v-if="itemBenefitPrincipal.nameProcess !== 'Eliminado'")
                                  .beneficiarios-item-edit.g-flex.align-end.cursor-pointer.justify-space-between(:class="{ 'active-benefit': itemBenefitPrincipal.show }", @click="viewBeneficiario(itemBenefitPrincipal)")
                                    div
                                      p.mb-0 Beneficiario {{ indexBenefitPrincipal + 1 }}
                                      p.mb-0 {{itemBenefitPrincipal.name}}
                                    .d-inline-flex.align-center
                                      p.font-weight-bold.text-blue.mb-0.mr-2 Editar
                                      svg(:class="{ 'g-rotate-180': itemBenefitPrincipal.show }",width='12' height='8' viewbox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg')
                                        path(d='M11.5822 0.88047C11.4897 0.789117 11.3798 0.71664 11.2588 0.66719C11.1379 0.617739 11.0082 0.592285 10.8772 0.592285C10.7462 0.592285 10.6166 0.617739 10.4956 0.66719C10.3746 0.71664 10.2647 0.789117 10.1722 0.88047L6.29222 4.70396L2.41222 0.88047C2.22524 0.696216 1.97164 0.592702 1.70722 0.592702C1.44279 0.592702 1.18919 0.696216 1.00222 0.88047C0.815238 1.06472 0.710196 1.31463 0.710196 1.5752C0.710196 1.83578 0.815238 2.08568 1.00222 2.26993L5.59222 6.79308C5.68473 6.88443 5.79462 6.95691 5.91559 7.00636C6.03656 7.05581 6.16625 7.08126 6.29722 7.08126C6.42818 7.08126 6.55787 7.05581 6.67884 7.00636C6.79981 6.95691 6.9097 6.88443 7.00222 6.79308L11.5922 2.26993C11.9722 1.89547 11.9722 1.26479 11.5822 0.88047Z' fill='#0855C4')
                                  div(v-show="itemBenefitPrincipal.show")
                                    .g-input
                                      v-text-field(v-model='itemBenefitPrincipal.name', outline, placeholder="-", label="Nombre del beneficiario" :disabled="disableParent(itemBenefitPrincipal.parent)")
                                        template(v-slot:append='')
                                          img(:src="icons.iconPencil" alt="iconPencil" v-if="!disableParent(itemBenefitPrincipal.parent)")
                                    .g-input
                                      v-text-field(v-model='itemBenefitPrincipal.paternal_surname', outline, placeholder="-", label="Apellido paterno del beneficiario" :disabled="disableParent(itemBenefitPrincipal.parent)")
                                        template(v-slot:append='')
                                          img(:src="icons.iconPencil" alt="iconPencil" v-if="!disableParent(itemBenefitPrincipal.parent)")
                                    .g-input
                                      v-text-field(v-model='itemBenefitPrincipal.maternal_surname', outline, placeholder="-", label="Apellido materno del beneficiario" :disabled="disableParent(itemBenefitPrincipal.parent)")
                                        template(v-slot:append='')
                                          img(:src="icons.iconPencil" alt="iconPencil" v-if="!disableParent(itemBenefitPrincipal.parent)")
                                    .g-input
                                      v-text-field(v-model='itemBenefitPrincipal.number_document', outline, placeholder="-", label="N° de documento", v-on:keypress="verifyChars($event)", maxlength="8" :disabled="disableParent(itemBenefitPrincipal.parent)")
                                        template(v-slot:append='')
                                          img(:src="icons.iconPencil" alt="iconPencil" v-if="!disableParent(itemBenefitPrincipal.parent)")
                                    .g-select
                                      v-select(:items="listParent", v-model='itemBenefitPrincipal.parent', outline, label="Parentesco", v-if="!disableParent(itemBenefitPrincipal.parent)"  @change="optionOtherParent(itemBenefitPrincipal)")
                                      v-text-field(v-model='itemBenefitPrincipal.parent', outline, placeholder="-", label="Parentesco", disabled, v-if="disableParent(itemBenefitPrincipal.parent)")
                                    .g-input
                                      v-text-field(v-model='itemBenefitPrincipal.distribution', outline, placeholder="-", v-on:keypress="verifyChars($event)")
                                        template(v-slot:append='')
                                          img(:src="icons.iconPencil" alt="iconPencil")
                                        template(v-slot:label='')
                                          span % Distribución
                                          svg(width='16' height='16' viewbox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' @click="showTooltip('distribution')")
                                            path(d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z' fill='#D0D6E0')
                                            path(d='M7.8557 9.55915C8.14494 9.55915 8.34801 9.47115 8.3714 9.28223C8.39663 8.38869 9.01324 8.025 9.62986 7.6213C9.98909 7.45188 10.2938 7.18534 10.5094 6.8518C10.7251 6.51826 10.8431 6.13104 10.8502 5.73392C10.8502 4.48838 9.85632 3.59484 8.22063 3.59484C7.47641 3.5623 6.74769 3.81422 6.18247 4.29946C5.99381 4.45927 5.83882 4.65501 5.72652 4.87529C5.61421 5.09557 5.54684 5.33598 5.52832 5.58253C5.52832 6.25946 6.39663 6.28715 6.40894 6.24961C6.43625 5.80183 6.63886 5.38284 6.97289 5.08337C7.30691 4.7839 7.74546 4.62806 8.19355 4.64961C9.0994 4.64961 9.61509 5.11484 9.61509 5.83238C9.61509 6.48654 9.06124 6.72592 8.49509 7.10315C8.13447 7.30345 7.83525 7.59823 7.62957 7.95581C7.42389 8.31339 7.31953 8.72026 7.3277 9.13269C7.31478 9.42069 7.54124 9.55915 7.8557 9.55915ZM7.79417 11.9745H7.97017C8.06258 11.9866 8.15654 11.9776 8.24495 11.9481C8.33336 11.9186 8.41391 11.8694 8.48053 11.8042C8.54714 11.739 8.59808 11.6595 8.62949 11.5718C8.6609 11.484 8.67197 11.3903 8.66186 11.2976V11.1468C8.67323 11.053 8.66315 10.9579 8.63238 10.8685C8.60161 10.7792 8.55095 10.698 8.48422 10.6311C8.41749 10.5642 8.33643 10.5133 8.24717 10.4823C8.15791 10.4513 8.06277 10.4409 7.96894 10.4521H7.79294C7.70049 10.4429 7.60716 10.4547 7.51986 10.4864C7.43255 10.5182 7.35349 10.5691 7.28851 10.6355C7.22353 10.7019 7.1743 10.782 7.14444 10.87C7.11459 10.958 7.10487 11.0515 7.11601 11.1438V11.2945C7.10499 11.3862 7.11488 11.4792 7.14495 11.5665C7.17503 11.6538 7.22449 11.7332 7.28964 11.7986C7.35479 11.8641 7.43392 11.9139 7.52109 11.9444C7.60826 11.9748 7.70121 11.9851 7.79294 11.9745H7.79417Z' fill='white')

                                    //- .g-input
                                      v-text-field(v-model='itemBenefitPrincipal.date_of_birth', outline, placeholder="-", label="Fecha de Nacimiento")
                                        template(v-slot:append='')
                                          img(:src="icons.iconPencil" alt="iconPencil")
                                    .g-input
                                      v-dialog(:ref="'mainDialogDateBirth' + indexBenefitPrincipal" v-model='itemBenefitPrincipal.modal', :return-value.sync="itemBenefitPrincipal.date_of_birth" persistent='' lazy='' full-width='' width='290px' v-if="!disableParent(itemBenefitPrincipal.parent)")
                                        v-text-field(slot='activator', v-model="itemBenefitPrincipal.date_of_birth", outline, readonly='', placeholder="-", label="Fecha de Nacimiento" :disabled="disableParent(itemBenefitPrincipal.parent)")
                                          template(v-slot:append='')
                                            img(:src="icons.iconPencil" alt="iconPencil" v-if="!disableParent(itemBenefitPrincipal.parent)")
                                        v-date-picker(v-model="itemBenefitPrincipal.date_of_birth" locale="es-005" scrollable='' :max="new Date().toISOString().slice(0,10)")
                                          v-spacer
                                          v-btn(flat='' color='primary' @click="itemBenefitPrincipal.modal = false") Cancel
                                          v-btn(flat='' color='primary' @click="saveDateBirthBenef('principal', itemBenefitPrincipal, indexBenefitPrincipal)") OK
                                      v-text-field(v-model="itemBenefitPrincipal.date_of_birth", outline, readonly='', placeholder="-", label="Fecha de Nacimiento" disabled v-if="disableParent(itemBenefitPrincipal.parent)")
                                    .btns
                                      button(@click="openModalDelete(itemBenefitPrincipal, indexBenefitPrincipal, 'principal')").g-font-semibold.g-btn-delete Eliminar
                                      button(@click="openModalSave(itemBenefitPrincipal, indexBenefitPrincipal, 'principal')").g-font-semibold.g-btn-save Guardar
                              .g-flex.mt-2.align-center.cursor-pointer(@click="addBenefitPrincipal")
                                svg(width='17' height='17' viewbox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg')
                                  path(d='M8.00195 2.52344H8.99805C9.08659 2.52344 9.13086 2.56771 9.13086 2.65625V14.3438C9.13086 14.4323 9.08659 14.4766 8.99805 14.4766H8.00195C7.91341 14.4766 7.86914 14.4323 7.86914 14.3438V2.65625C7.86914 2.56771 7.91341 2.52344 8.00195 2.52344Z' fill='black')
                                  path(d='M2.92188 7.86914H14.0781C14.1667 7.86914 14.2109 7.91341 14.2109 8.00195V8.99805C14.2109 9.08659 14.1667 9.13086 14.0781 9.13086H2.92188C2.83333 9.13086 2.78906 9.08659 2.78906 8.99805V8.00195C2.78906 7.91341 2.83333 7.86914 2.92188 7.86914Z' fill='black')
                                p.mb-0 Agregar beneficiario
                          //-- SECCION BENEFICIARIOS CONTINGENTES - SOLO HABILITADO PARA LOS CLIENTES QUE NO SON DE VIDA CASH
                          .beneficiarios-step-1-section.mt-4(v-if="productName !== 'Vida Cash'")
                              .beneficiarios-step-1-subtitle
                                .g-flex.align-center.mt-3
                                  h2.font-weight-medium.text-blue.mr-2 Beneficiarios contingentes
                                  svg(width='16' height='16' viewbox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' @click="showTooltip('secondaryBenef')")
                                    path(d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z' fill='#D0D6E0')
                                    path(d='M7.8557 9.55915C8.14494 9.55915 8.34801 9.47115 8.3714 9.28223C8.39663 8.38869 9.01324 8.025 9.62986 7.6213C9.98909 7.45188 10.2938 7.18534 10.5094 6.8518C10.7251 6.51826 10.8431 6.13104 10.8502 5.73392C10.8502 4.48838 9.85632 3.59484 8.22063 3.59484C7.47641 3.5623 6.74769 3.81422 6.18247 4.29946C5.99381 4.45927 5.83882 4.65501 5.72652 4.87529C5.61421 5.09557 5.54684 5.33598 5.52832 5.58253C5.52832 6.25946 6.39663 6.28715 6.40894 6.24961C6.43625 5.80183 6.63886 5.38284 6.97289 5.08337C7.30691 4.7839 7.74546 4.62806 8.19355 4.64961C9.0994 4.64961 9.61509 5.11484 9.61509 5.83238C9.61509 6.48654 9.06124 6.72592 8.49509 7.10315C8.13447 7.30345 7.83525 7.59823 7.62957 7.95581C7.42389 8.31339 7.31953 8.72026 7.3277 9.13269C7.31478 9.42069 7.54124 9.55915 7.8557 9.55915ZM7.79417 11.9745H7.97017C8.06258 11.9866 8.15654 11.9776 8.24495 11.9481C8.33336 11.9186 8.41391 11.8694 8.48053 11.8042C8.54714 11.739 8.59808 11.6595 8.62949 11.5718C8.6609 11.484 8.67197 11.3903 8.66186 11.2976V11.1468C8.67323 11.053 8.66315 10.9579 8.63238 10.8685C8.60161 10.7792 8.55095 10.698 8.48422 10.6311C8.41749 10.5642 8.33643 10.5133 8.24717 10.4823C8.15791 10.4513 8.06277 10.4409 7.96894 10.4521H7.79294C7.70049 10.4429 7.60716 10.4547 7.51986 10.4864C7.43255 10.5182 7.35349 10.5691 7.28851 10.6355C7.22353 10.7019 7.1743 10.782 7.14444 10.87C7.11459 10.958 7.10487 11.0515 7.11601 11.1438V11.2945C7.10499 11.3862 7.11488 11.4792 7.14495 11.5665C7.17503 11.6538 7.22449 11.7332 7.28964 11.7986C7.35479 11.8641 7.43392 11.9139 7.52109 11.9444C7.60826 11.9748 7.70121 11.9851 7.79294 11.9745H7.79417Z' fill='white')
                                p.mb-0.mt-1 Solo se puede agregar un máximo de 2 beneficiarios contingentes.
                              .beneficiarios-step-1-list
                                article(v-for="(itemBenefitContingentes, indexBenefitContingentes) in listBeneficiariosContingentes", :key="indexBenefitContingentes")
                                  .beneficiarios-item-edit.g-flex.align-end.cursor-pointer.justify-space-between(:class="{'active-benefit': itemBenefitContingentes.show}", @click="viewBeneficiario(itemBenefitContingentes)")
                                    div
                                      p.mb-0 Beneficiario {{ indexBenefitContingentes + 1 }}
                                      p.mb-0 {{itemBenefitContingentes.name}}
                                    .d-inline-flex.align-center
                                      p.font-weight-bold.text-blue.mb-0.mr-2 Editar
                                      svg(:class="{'g-rotate-180': itemBenefitContingentes.show}", width='12' height='8' viewbox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg')
                                        path(d='M11.5822 0.88047C11.4897 0.789117 11.3798 0.71664 11.2588 0.66719C11.1379 0.617739 11.0082 0.592285 10.8772 0.592285C10.7462 0.592285 10.6166 0.617739 10.4956 0.66719C10.3746 0.71664 10.2647 0.789117 10.1722 0.88047L6.29222 4.70396L2.41222 0.88047C2.22524 0.696216 1.97164 0.592702 1.70722 0.592702C1.44279 0.592702 1.18919 0.696216 1.00222 0.88047C0.815238 1.06472 0.710196 1.31463 0.710196 1.5752C0.710196 1.83578 0.815238 2.08568 1.00222 2.26993L5.59222 6.79308C5.68473 6.88443 5.79462 6.95691 5.91559 7.00636C6.03656 7.05581 6.16625 7.08126 6.29722 7.08126C6.42818 7.08126 6.55787 7.05581 6.67884 7.00636C6.79981 6.95691 6.9097 6.88443 7.00222 6.79308L11.5922 2.26993C11.9722 1.89547 11.9722 1.26479 11.5822 0.88047Z' fill='#0855C4')
                                  div(v-show="itemBenefitContingentes.show")
                                    .g-input
                                      v-text-field(v-model='itemBenefitContingentes.name', outline, placeholder="-", label="Nombre del beneficiario" :disabled="disableParent(itemBenefitContingentes.parent)")
                                        template(v-slot:append='')
                                          img(:src="icons.iconPencil" alt="iconPencil" v-if="!disableParent(itemBenefitContingentes.parent)")
                                    .g-input
                                      v-text-field(v-model='itemBenefitContingentes.paternal_surname', outline, placeholder="-", label="Apellido Paterno del beneficiario" :disabled="disableParent(itemBenefitContingentes.parent)")
                                        template(v-slot:append='')
                                          img(:src="icons.iconPencil" alt="iconPencil" v-if="!disableParent(itemBenefitContingentes.parent)")
                                    .g-input
                                      v-text-field(v-model='itemBenefitContingentes.maternal_surname', outline, placeholder="-", label="Apellido Materno del beneficiario" :disabled="disableParent(itemBenefitContingentes.parent)")
                                        template(v-slot:append='')
                                          img(:src="icons.iconPencil" alt="iconPencil" v-if="!disableParent(itemBenefitContingentes.parent)")
                                    .g-input
                                      v-text-field(v-model='itemBenefitContingentes.number_document', outline, placeholder="-", label="N° de documento" :disabled="disableParent(itemBenefitContingentes.parent)")
                                        template(v-slot:append='')
                                          img(:src="icons.iconPencil" alt="iconPencil" v-if="!disableParent(itemBenefitContingentes.parent)")
                                    .g-select
                                      v-select(:items="listParent", v-model='itemBenefitContingentes.parent', outline, label="Parentesco", v-if="!disableParent(itemBenefitContingentes.parent)" @change="optionOtherParent(itemBenefitContingentes)")
                                      v-text-field(v-model='itemBenefitContingentes.parent', outline, label="Parentesco", disabled, v-if="disableParent(itemBenefitContingentes.parent)")
                                    .g-input
                                      v-text-field(v-model='itemBenefitContingentes.distribution', outline, placeholder="-", label="% Distribución")
                                        template(v-slot:append='')
                                          img(:src="icons.iconPencil" alt="iconPencil")
                                    //- .g-input
                                      v-text-field(v-model='itemBenefitContingentes.date_of_birth', outline, placeholder="-", label="Fecha de Nacimiento")
                                        template(v-slot:append='')
                                          img(:src="icons.iconPencil" alt="iconPencil")
                                    .g-input
                                      v-dialog(:ref="'secondDialogDateBirth' + indexBenefitContingentes" v-model='itemBenefitContingentes.modal', :return-value.sync="itemBenefitContingentes.date_of_birth" persistent='' lazy='' full-width='' width='290px', v-if="!disableParent(itemBenefitContingentes.parent)")
                                        v-text-field(slot='activator', v-model="itemBenefitContingentes.date_of_birth", outline, readonly='', placeholder="-", label="Fecha de Nacimiento")
                                          template(v-slot:append='')
                                            img(:src="icons.iconPencil" alt="iconPencil")
                                        v-date-picker(v-model="itemBenefitContingentes.date_of_birth" locale="es-005" scrollable='' :max="new Date().toISOString().slice(0,10)")
                                          v-spacer
                                          v-btn(flat='' color='primary' @click="itemBenefitContingentes.modal = false") Cancel
                                          v-btn(flat='' color='primary' @click="saveDateBirthBenef('contingente', itemBenefitContingentes, indexBenefitContingentes)") OK
                                      v-text-field(v-model="itemBenefitContingentes.date_of_birth", outline, readonly='', placeholder="-", label="Fecha de Nacimiento", v-if="disableParent(itemBenefitContingentes.parent)")
                                    .btns
                                      button(@click="openModalDelete(itemBenefitContingentes, indexBenefitContingentes, 'contingente')").g-font-semibold.g-btn-delete Eliminar
                                      button(@click="openModalSave(itemBenefitContingentes, indexBenefitContingentes, 'contingente')").g-font-semibold.g-btn-save Guardar
                              .g-flex.mt-2.cursor-pointer.align-center.mt-2(@click="addBenefitContingentes")
                                svg(width='17' height='17' viewbox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg')
                                  path(d='M8.00195 2.52344H8.99805C9.08659 2.52344 9.13086 2.56771 9.13086 2.65625V14.3438C9.13086 14.4323 9.08659 14.4766 8.99805 14.4766H8.00195C7.91341 14.4766 7.86914 14.4323 7.86914 14.3438V2.65625C7.86914 2.56771 7.91341 2.52344 8.00195 2.52344Z' fill='black')
                                  path(d='M2.92188 7.86914H14.0781C14.1667 7.86914 14.2109 7.91341 14.2109 8.00195V8.99805C14.2109 9.08659 14.1667 9.13086 14.0781 9.13086H2.92188C2.83333 9.13086 2.78906 9.08659 2.78906 8.99805V8.00195C2.78906 7.91341 2.83333 7.86914 2.92188 7.86914Z' fill='black')
                                p.mb-0.ml-1 Agregar beneficiario
                          .beneficiarios-step-1-email.mt-3
                              p.mt-3 Este es el correo electrónico donde te llegará la solicitud.
                              .g-input.mt-1
                                v-text-field(v-model='txtEmail', outline, placeholder="-", label="Correo electrónico")
                                  template(v-slot:append='')
                                    img(:src="icons.iconPencil" alt="iconPencil")
                          p.mb-0.mt-4.beneficiarios-step-1-politicas
                            | Al continuar acepto las
                            a(href="https://documentos.interseguro.com.pe/PDF/PoliticaPrivacidadInterseguro.pdf" target="_blank").font-weight-medium  condiciones de uso y políticas de privacidad.
                          .g-flex.mt-3.beneficiarios-step-1-jurada
                            input(type="checkbox" v-model="inputJurada")
                            label Acepto la
                              a(href="#", @click="tooltips.declaracion = true").font-weight-medium  declaración jurada.
                          .beneficiarios-btn
                            div(:class="{ 'btn-purple': inputJurada }", @click="openStep2").mx-auto.g-font-semibold Siguiente
                      .beneficiarios-step-2(v-show="step2")
                          .beneficiarios-step-1-title
                            h2.font-weight-medium.text-blue.text-xs-center Resumen de solicitud
                          .g-flex.justify-space-between.beneficiarios-step-2-descrip
                            p N° documento del titular:
                            p {{ basicInfo.numeroDocumento }}
                          .g-flex.justify-space-between.beneficiarios-step-2-descrip
                            p Producto:
                            p {{ productName }}
                          .g-flex.justify-space-between.beneficiarios-step-2-descrip
                            p Póliza:
                            p {{ policy }}
                          .g-flex.justify-space-between.beneficiarios-step-2-descrip
                            p Tipo de solicitud:
                            p(style="text-align: right") Modificación de beneficiarios
                          .g-flex.beneficiarios-step-2-descrip
                            p Beneficiarios a actualizar:
                          .beneficiarios-step-2-list
                              article
                                .g-flex.align-center.beneficiarios-step-2-item-title
                                  h3 Beneficiarios principales
                                  svg(width='16' height='16' viewbox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' @click="showTooltip('mainBenef')")
                                    path(d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z' fill='#D0D6E0')
                                    path(d='M7.8557 9.55915C8.14494 9.55915 8.34801 9.47115 8.3714 9.28223C8.39663 8.38869 9.01324 8.025 9.62986 7.6213C9.98909 7.45188 10.2938 7.18534 10.5094 6.8518C10.7251 6.51826 10.8431 6.13104 10.8502 5.73392C10.8502 4.48838 9.85632 3.59484 8.22063 3.59484C7.47641 3.5623 6.74769 3.81422 6.18247 4.29946C5.99381 4.45927 5.83882 4.65501 5.72652 4.87529C5.61421 5.09557 5.54684 5.33598 5.52832 5.58253C5.52832 6.25946 6.39663 6.28715 6.40894 6.24961C6.43625 5.80183 6.63886 5.38284 6.97289 5.08337C7.30691 4.7839 7.74546 4.62806 8.19355 4.64961C9.0994 4.64961 9.61509 5.11484 9.61509 5.83238C9.61509 6.48654 9.06124 6.72592 8.49509 7.10315C8.13447 7.30345 7.83525 7.59823 7.62957 7.95581C7.42389 8.31339 7.31953 8.72026 7.3277 9.13269C7.31478 9.42069 7.54124 9.55915 7.8557 9.55915ZM7.79417 11.9745H7.97017C8.06258 11.9866 8.15654 11.9776 8.24495 11.9481C8.33336 11.9186 8.41391 11.8694 8.48053 11.8042C8.54714 11.739 8.59808 11.6595 8.62949 11.5718C8.6609 11.484 8.67197 11.3903 8.66186 11.2976V11.1468C8.67323 11.053 8.66315 10.9579 8.63238 10.8685C8.60161 10.7792 8.55095 10.698 8.48422 10.6311C8.41749 10.5642 8.33643 10.5133 8.24717 10.4823C8.15791 10.4513 8.06277 10.4409 7.96894 10.4521H7.79294C7.70049 10.4429 7.60716 10.4547 7.51986 10.4864C7.43255 10.5182 7.35349 10.5691 7.28851 10.6355C7.22353 10.7019 7.1743 10.782 7.14444 10.87C7.11459 10.958 7.10487 11.0515 7.11601 11.1438V11.2945C7.10499 11.3862 7.11488 11.4792 7.14495 11.5665C7.17503 11.6538 7.22449 11.7332 7.28964 11.7986C7.35479 11.8641 7.43392 11.9139 7.52109 11.9444C7.60826 11.9748 7.70121 11.9851 7.79294 11.9745H7.79417Z' fill='white')
                                .beneficiarios-step-2-item(v-for="(itemBenefitPrincipal, indexBenefitPrincipal) in listBeneficiariosPri", v-if="itemBenefitPrincipal.nameProcess !== ''")
                                    .beneficiarios-item-edit.mb-2.g-flex.align-end.cursor-pointer.justify-space-between(:class="{'active-benefit': itemBenefitPrincipal.show}", @click="viewBeneficiarioOnResumen(itemBenefitPrincipal)")
                                      div
                                        p.mb-0 Beneficiario {{ indexBenefitPrincipal + 1}}
                                        p.mb-0 {{ itemBenefitPrincipal.name + ' ' + itemBenefitPrincipal.paternal_surname + ' ' + itemBenefitPrincipal.maternal_surname }}
                                      .d-inline-flex.align-center
                                          p.mb-0.mr-2(:class="{ 'text-blue': itemBenefitPrincipal.nameProcess !== 'Eliminado' }", :style="itemBenefitPrincipal.nameProcess === 'Eliminado' ? 'color: #EB5757 !important' : ''")
                                            | {{ itemBenefitPrincipal.nameProcess }}
                                          svg(:class="{ 'g-rotate-180': itemBenefitPrincipal.show }",width='12' height='8' viewbox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg')
                                            path(d='M11.5822 0.88047C11.4897 0.789117 11.3798 0.71664 11.2588 0.66719C11.1379 0.617739 11.0082 0.592285 10.8772 0.592285C10.7462 0.592285 10.6166 0.617739 10.4956 0.66719C10.3746 0.71664 10.2647 0.789117 10.1722 0.88047L6.29222 4.70396L2.41222 0.88047C2.22524 0.696216 1.97164 0.592702 1.70722 0.592702C1.44279 0.592702 1.18919 0.696216 1.00222 0.88047C0.815238 1.06472 0.710196 1.31463 0.710196 1.5752C0.710196 1.83578 0.815238 2.08568 1.00222 2.26993L5.59222 6.79308C5.68473 6.88443 5.79462 6.95691 5.91559 7.00636C6.03656 7.05581 6.16625 7.08126 6.29722 7.08126C6.42818 7.08126 6.55787 7.05581 6.67884 7.00636C6.79981 6.95691 6.9097 6.88443 7.00222 6.79308L11.5922 2.26993C11.9722 1.89547 11.9722 1.26479 11.5822 0.88047Z' fill='#0855C4')
                                    .beneficiarios-step-2-item-content(v-show="itemBenefitPrincipal.show")
                                      .g-flex
                                        p Nombres:
                                        p {{ itemBenefitPrincipal.name }}
                                      .g-flex
                                        p Apellidos:
                                        p {{ itemBenefitPrincipal.paternal_surname + ' ' + itemBenefitPrincipal.maternal_surname }}
                                      .g-flex
                                        p Documento:
                                        p {{ itemBenefitPrincipal.number_document }}
                                      .g-flex
                                        p Parentesco:
                                        p {{ itemBenefitPrincipal.parent }}
                                      .g-flex
                                        p % Distribución:
                                        p {{ itemBenefitPrincipal.distribution }}%
                                      .g-flex
                                        p Fecha de Nacimiento:
                                        p {{ itemBenefitPrincipal.date_of_birth }}
                              article(v-if="listBeneficiariosCont.length > 0")
                                .g-flex.align-center.beneficiarios-step-2-item-title
                                    h3 Beneficiarios contingentes
                                    svg(width='16' height='16' viewbox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' @click="showTooltip('secondaryBenef')")
                                        path(d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z' fill='#D0D6E0')
                                        path(d='M7.8557 9.55915C8.14494 9.55915 8.34801 9.47115 8.3714 9.28223C8.39663 8.38869 9.01324 8.025 9.62986 7.6213C9.98909 7.45188 10.2938 7.18534 10.5094 6.8518C10.7251 6.51826 10.8431 6.13104 10.8502 5.73392C10.8502 4.48838 9.85632 3.59484 8.22063 3.59484C7.47641 3.5623 6.74769 3.81422 6.18247 4.29946C5.99381 4.45927 5.83882 4.65501 5.72652 4.87529C5.61421 5.09557 5.54684 5.33598 5.52832 5.58253C5.52832 6.25946 6.39663 6.28715 6.40894 6.24961C6.43625 5.80183 6.63886 5.38284 6.97289 5.08337C7.30691 4.7839 7.74546 4.62806 8.19355 4.64961C9.0994 4.64961 9.61509 5.11484 9.61509 5.83238C9.61509 6.48654 9.06124 6.72592 8.49509 7.10315C8.13447 7.30345 7.83525 7.59823 7.62957 7.95581C7.42389 8.31339 7.31953 8.72026 7.3277 9.13269C7.31478 9.42069 7.54124 9.55915 7.8557 9.55915ZM7.79417 11.9745H7.97017C8.06258 11.9866 8.15654 11.9776 8.24495 11.9481C8.33336 11.9186 8.41391 11.8694 8.48053 11.8042C8.54714 11.739 8.59808 11.6595 8.62949 11.5718C8.6609 11.484 8.67197 11.3903 8.66186 11.2976V11.1468C8.67323 11.053 8.66315 10.9579 8.63238 10.8685C8.60161 10.7792 8.55095 10.698 8.48422 10.6311C8.41749 10.5642 8.33643 10.5133 8.24717 10.4823C8.15791 10.4513 8.06277 10.4409 7.96894 10.4521H7.79294C7.70049 10.4429 7.60716 10.4547 7.51986 10.4864C7.43255 10.5182 7.35349 10.5691 7.28851 10.6355C7.22353 10.7019 7.1743 10.782 7.14444 10.87C7.11459 10.958 7.10487 11.0515 7.11601 11.1438V11.2945C7.10499 11.3862 7.11488 11.4792 7.14495 11.5665C7.17503 11.6538 7.22449 11.7332 7.28964 11.7986C7.35479 11.8641 7.43392 11.9139 7.52109 11.9444C7.60826 11.9748 7.70121 11.9851 7.79294 11.9745H7.79417Z' fill='white')
                                .beneficiarios-step-2-item(v-for="(itemBenefitContingentes, indexBenefitContingentes) in listBeneficiariosCont", v-if="itemBenefitContingentes.nameProcess !== ''")
                                    .beneficiarios-item-edit.mb-2.g-flex.align-end.cursor-pointer.justify-space-between(:class="{'active-benefit': itemBenefitContingentes.show}", @click="viewBeneficiarioOnResumen(itemBenefitContingentes)")
                                      div
                                        p.mb-0 Beneficiario {{indexBenefitContingentes + 1}}
                                        p.mb-0 {{ itemBenefitContingentes.name + ' ' + itemBenefitContingentes.paternal_surname + ' ' + itemBenefitContingentes.maternal_surname }}
                                      .d-inline-flex.align-center
                                        p.text-blue.mb-0.mr-2 {{itemBenefitContingentes.nameProcess}}
                                        svg(:class="{'g-rotate-180': itemBenefitContingentes.show}",width='12' height='8' viewbox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg')
                                            path(d='M11.5822 0.88047C11.4897 0.789117 11.3798 0.71664 11.2588 0.66719C11.1379 0.617739 11.0082 0.592285 10.8772 0.592285C10.7462 0.592285 10.6166 0.617739 10.4956 0.66719C10.3746 0.71664 10.2647 0.789117 10.1722 0.88047L6.29222 4.70396L2.41222 0.88047C2.22524 0.696216 1.97164 0.592702 1.70722 0.592702C1.44279 0.592702 1.18919 0.696216 1.00222 0.88047C0.815238 1.06472 0.710196 1.31463 0.710196 1.5752C0.710196 1.83578 0.815238 2.08568 1.00222 2.26993L5.59222 6.79308C5.68473 6.88443 5.79462 6.95691 5.91559 7.00636C6.03656 7.05581 6.16625 7.08126 6.29722 7.08126C6.42818 7.08126 6.55787 7.05581 6.67884 7.00636C6.79981 6.95691 6.9097 6.88443 7.00222 6.79308L11.5922 2.26993C11.9722 1.89547 11.9722 1.26479 11.5822 0.88047Z' fill='#0855C4')
                                    .beneficiarios-step-2-item-content(v-show="itemBenefitContingentes.show")
                                        .g-flex
                                          p Nombres:
                                          p {{ itemBenefitContingentes.name }}
                                        .g-flex
                                          p Apellidos:
                                          p {{ itemBenefitContingentes.paternal_surname + ' ' + itemBenefitContingentes.maternal_surname }}
                                        .g-flex
                                          p Documento:
                                          p {{ itemBenefitContingentes.number_document }}
                                        .g-flex
                                          p Parentesco:
                                          p {{ itemBenefitContingentes.parent }}
                                        .g-flex
                                          p % Distribución:
                                          p {{ itemBenefitContingentes.distribution }}%
                                        .g-flex
                                          p Fecha de Nacimiento:
                                          p {{ itemBenefitContingentes.date_of_birth }}
                          .g-flex.justify-space-between.beneficiarios-step-2-descrip
                              p Fecha de solicitud:
                              p {{ now }}
                          .mb-5
                            .beneficiarios-item-edit.mt-3.g-flex.align-end.cursor-pointer.justify-space-between(:class="{'active-benefit': showTxtEmail}", @click="showTxtEmail = !showTxtEmail")
                              div
                                p.mb-0 Correo de envío de solicitud
                                p.mb-0 {{ txtEmail }}
                              .d-inline-flex.align-center
                                p.font-weight-bold.text-blue.mb-0.mr-2 Editar
                                svg(:class="{'g-rotate-180': showTxtEmail}",width='12' height='8' viewbox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg')
                                  path(d='M11.5822 0.88047C11.4897 0.789117 11.3798 0.71664 11.2588 0.66719C11.1379 0.617739 11.0082 0.592285 10.8772 0.592285C10.7462 0.592285 10.6166 0.617739 10.4956 0.66719C10.3746 0.71664 10.2647 0.789117 10.1722 0.88047L6.29222 4.70396L2.41222 0.88047C2.22524 0.696216 1.97164 0.592702 1.70722 0.592702C1.44279 0.592702 1.18919 0.696216 1.00222 0.88047C0.815238 1.06472 0.710196 1.31463 0.710196 1.5752C0.710196 1.83578 0.815238 2.08568 1.00222 2.26993L5.59222 6.79308C5.68473 6.88443 5.79462 6.95691 5.91559 7.00636C6.03656 7.05581 6.16625 7.08126 6.29722 7.08126C6.42818 7.08126 6.55787 7.05581 6.67884 7.00636C6.79981 6.95691 6.9097 6.88443 7.00222 6.79308L11.5922 2.26993C11.9722 1.89547 11.9722 1.26479 11.5822 0.88047Z' fill='#0855C4')
                            .g-input.mt-1(v-show="showTxtEmail")
                              v-text-field(v-model='txtEmail', outline, placeholder="-", label="Correo electrónico")
                                template(v-slot:append='')
                                  img(:src="icons.iconPencil" alt="iconPencil")
                          .beneficiarios-btn
                              div.btn-purple(@click="openStep3").mx-auto.g-font-semibold Continuar
                              a(href="#", @click="backToStep1()") Volver
                      .beneficiarios-step-3(v-show="step3")
                        .beneficiarios-step-3-title
                          h2.text-blue Validación
                          figure.text-xs-center
                            img(src="../assets/beneficiarios/img-validar.png")
                          h3 Necesitamos validar que eres tú
                        section(v-show="step3Part1")
                            p.beneficiarios-step-3-subtitle.mb-0 Elige una de estas opciones para enviarte el código de verificación.
                            .beneficiarios-step3-input.mt-4(@click="checkEmail", :class="{'active-input': activeStep3Email}")
                              .g-flex.align-center
                                div
                                  .style-table-circle(:class="{'bg-blue': activeStep3Email}")
                                    v-icon(v-show="activeStep3Email") check
                                div
                                  p.g-font-medium Correo electrónico
                                  p.g-font-medium {{ emailEncript }}
                            .beneficiarios-step3-input.mb-5.mt-4(@click="checkPhone", :class="{'active-input': activeStep3Phone}")
                              .g-flex.align-center
                                div
                                  .style-table-circle(:class="{'bg-blue': activeStep3Phone}")
                                    v-icon(v-show="activeStep3Phone") check
                                div
                                  p.g-font-medium Celular
                                  p.g-font-medium {{ celularEncript }}
                            .beneficiarios-btn(:style="sizeWidth.large ? 'padding: 0 21%' : 'padding: 0 12%'")
                              div(@click="openStep3Part1", :class="{ 'btn-purple': activeStep3Email || activeStep3Phone }").mx-auto.g-font-semibold Enviar código
                              a(href="#", @click="goToProfile()") Quiero actualizar mi celular y/o correo electrónico
                        section(v-show="step3Part2")
                            p.beneficiarios-step-3-subtitle.mb-0.text-gris Te hemos enviado el código al {{ activeStep3Email ? 'correo ' + emailEncript : 'celular ' + celularEncript }}
                            .beneficiarios-step-3-code.mx-auto
                              v-text-field(type="tel", v-model="code", ref="code", maxlength="1", placeholder=" ", @keyup.native="validateCode($event, 1)", hide-details)
                              v-text-field(type="tel", v-model="code2", ref="code2", maxlength="1", placeholder=" ", @keyup.native="validateCode($event, 2)", hide-details)
                              v-text-field(type="tel", v-model="code3", ref="code3", maxlength="1", placeholder=" ", @keyup.native="validateCode($event, 3)", hide-details)
                              v-text-field(type="tel", v-model="code4", ref="code4", maxlength="1", placeholder=" ", @keyup.native="validateCode($event, 4)", hide-details)
                              v-text-field(type="tel", v-model="code5", ref="code5", maxlength="1", placeholder=" ", @keyup.native="validateCode($event, 5)", hide-details)
                            .mx-auto.beneficiarios-step-3-text-confirm
                              p Al hacer clic en confirmar, acepto el envío de mi solicitud junto con los términos y condiciones de la misma
                            .beneficiarios-btn(:style="sizeWidth.large ? 'padding: 0 27%' : 'padding: 0 15%'")
                              div(@click="openFinish", :class="{ 'btn-purple': code && code2 && code3 && code4 && code5 }").mx-auto.g-font-semibold Confirmar
                  .beneficiarios-finish(v-show="stepFinish")
                    section
                      figure.mb-4.text-xs-center
                        img(src="../assets/beneficiarios/img-finish.png")
                      h2.text-xs-center.text-blue  ¡Su solicitud ha sido recibida con éxito!
                      p.mx-auto Recibirás el estado de tu solicitud por correo y verás tus cambios reflejados en tu <strong>Zona Segura</strong> en el plazo de 1 día hábil.
                    section
                      .beneficiarios-finish-container.mx-auto
                        h2.mx-auto.text-xs-center.text-blue Estos son tus beneficiaros actualmente
                        .beneficiarios-finish-descrip
                          .g-flex.justify-space-between
                            p N° documento del titular:
                            p {{ basicInfo.numeroDocumento }}
                          .g-flex.justify-space-between
                            p Producto:
                            p {{ productName }}
                          .g-flex.justify-space-between
                            p Póliza:
                            p {{ policy }}
                        .beneficiarios-finish-list
                          article
                            .g-flex.align-center
                              h4 Beneficiarios principales
                              svg(width='16' height='16' viewbox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg')
                                path(d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z' fill='#D0D6E0')
                                path(d='M7.85668 9.55915C8.14591 9.55915 8.34899 9.47115 8.37237 9.28223C8.3976 8.38869 9.01422 8.025 9.63083 7.6213C9.99007 7.45188 10.2947 7.18534 10.5104 6.8518C10.726 6.51826 10.8441 6.13104 10.8511 5.73392C10.8511 4.48838 9.8573 3.59484 8.2216 3.59484C7.47738 3.5623 6.74867 3.81422 6.18345 4.29946C5.99479 4.45927 5.8398 4.65501 5.7275 4.87529C5.61519 5.09557 5.54782 5.33598 5.5293 5.58253C5.5293 6.25946 6.3976 6.28715 6.40991 6.24961C6.43723 5.80183 6.63984 5.38284 6.97386 5.08337C7.30789 4.7839 7.74643 4.62806 8.19453 4.64961C9.10037 4.64961 9.61607 5.11484 9.61607 5.83238C9.61607 6.48654 9.06222 6.72592 8.49607 7.10315C8.13545 7.30345 7.83623 7.59823 7.63055 7.95581C7.42487 8.31339 7.32051 8.72026 7.32868 9.13269C7.31576 9.42069 7.54222 9.55915 7.85668 9.55915ZM7.79514 11.9745H7.97114C8.06356 11.9866 8.15752 11.9776 8.24593 11.9481C8.33434 11.9186 8.41489 11.8694 8.4815 11.8042C8.54812 11.739 8.59905 11.6595 8.63046 11.5718C8.66188 11.484 8.67295 11.3903 8.66283 11.2976V11.1468C8.67421 11.053 8.66413 10.9579 8.63336 10.8685C8.60258 10.7792 8.55192 10.698 8.48519 10.6311C8.41846 10.5642 8.33741 10.5133 8.24815 10.4823C8.15889 10.4513 8.06375 10.4409 7.96991 10.4521H7.79391C7.70146 10.4429 7.60814 10.4547 7.52083 10.4864C7.43353 10.5182 7.35447 10.5691 7.28949 10.6355C7.22451 10.7019 7.17528 10.782 7.14542 10.87C7.11556 10.958 7.10585 11.0515 7.11699 11.1438V11.2945C7.10596 11.3862 7.11586 11.4792 7.14593 11.5665C7.176 11.6538 7.22547 11.7332 7.29062 11.7986C7.35577 11.8641 7.4349 11.9139 7.52207 11.9444C7.60924 11.9748 7.70218 11.9851 7.79391 11.9745H7.79514Z' fill='white')
                            .beneficiarios-finish-item(v-for="(itemPrincipal, indexPrincipal) in listBeneficiariosPrincipal", :key="indexPrincipal")
                                p Beneficiario {{indexPrincipal + 1}}
                                p {{itemPrincipal.name}}
                          article
                            .g-flex.align-center
                              h4 Beneficiarios contingentes
                              svg(width='16' height='16' viewbox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg')
                                path(d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z' fill='#D0D6E0')
                                path(d='M7.85668 9.55915C8.14591 9.55915 8.34899 9.47115 8.37237 9.28223C8.3976 8.38869 9.01422 8.025 9.63083 7.6213C9.99007 7.45188 10.2947 7.18534 10.5104 6.8518C10.726 6.51826 10.8441 6.13104 10.8511 5.73392C10.8511 4.48838 9.8573 3.59484 8.2216 3.59484C7.47738 3.5623 6.74867 3.81422 6.18345 4.29946C5.99479 4.45927 5.8398 4.65501 5.7275 4.87529C5.61519 5.09557 5.54782 5.33598 5.5293 5.58253C5.5293 6.25946 6.3976 6.28715 6.40991 6.24961C6.43723 5.80183 6.63984 5.38284 6.97386 5.08337C7.30789 4.7839 7.74643 4.62806 8.19453 4.64961C9.10037 4.64961 9.61607 5.11484 9.61607 5.83238C9.61607 6.48654 9.06222 6.72592 8.49607 7.10315C8.13545 7.30345 7.83623 7.59823 7.63055 7.95581C7.42487 8.31339 7.32051 8.72026 7.32868 9.13269C7.31576 9.42069 7.54222 9.55915 7.85668 9.55915ZM7.79514 11.9745H7.97114C8.06356 11.9866 8.15752 11.9776 8.24593 11.9481C8.33434 11.9186 8.41489 11.8694 8.4815 11.8042C8.54812 11.739 8.59905 11.6595 8.63046 11.5718C8.66188 11.484 8.67295 11.3903 8.66283 11.2976V11.1468C8.67421 11.053 8.66413 10.9579 8.63336 10.8685C8.60258 10.7792 8.55192 10.698 8.48519 10.6311C8.41846 10.5642 8.33741 10.5133 8.24815 10.4823C8.15889 10.4513 8.06375 10.4409 7.96991 10.4521H7.79391C7.70146 10.4429 7.60814 10.4547 7.52083 10.4864C7.43353 10.5182 7.35447 10.5691 7.28949 10.6355C7.22451 10.7019 7.17528 10.782 7.14542 10.87C7.11556 10.958 7.10585 11.0515 7.11699 11.1438V11.2945C7.10596 11.3862 7.11586 11.4792 7.14593 11.5665C7.176 11.6538 7.22547 11.7332 7.29062 11.7986C7.35577 11.8641 7.4349 11.9139 7.52207 11.9444C7.60924 11.9748 7.70218 11.9851 7.79391 11.9745H7.79514Z' fill='white')
                            .beneficiarios-finish-item(v-for="(itemContingente, indexContingente) in listBeneficiariosContingentes")
                              p Beneficiario {{indexContingente + 1}}
                              p {{itemContingente.name}}
                        .beneficiarios-finish-remenber.d-inline-flex
                          div
                            svg(width='20' height='20' viewbox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg')
                              circle(cx='10' cy='10' r='10' fill='#D0D6E0')
                              path(d='M9.75583 10.985H9.98083C10.2958 10.985 10.4308 10.76 10.5358 10.31L11.1208 5.495C11.3008 4.655 10.8508 4.16 10.0558 4.16H9.68083C8.91583 4.16 8.46583 4.655 8.64583 5.495L9.23083 10.31C9.33583 10.76 9.47083 10.985 9.75583 10.985ZM9.74083 14.105H9.99583C10.6858 14.105 11.0158 13.775 11.0158 13.115V12.905C11.0158 12.245 10.7008 11.915 9.99583 11.915H9.74083C9.08083 11.915 8.73583 12.245 8.73583 12.905V13.115C8.73583 13.775 9.08083 14.105 9.74083 14.105Z' fill='white')
                          p Recuerda que no podrás modificar tus beneficiarios hasta que la solicitud sea aprobada.
                        .beneficiarios-btn
                            div.btn-purple.mx-auto.g-font-semibold(@click="goToHome()") Ir al menú principal
                            a(href="#") Reenviar constancia
                            a(href="#") Descargar constancia
              v-flex(:lg2="sizeWidth.large", :lg1="sizeWidth.medium", :lg4="(step3 || stepFinish) && (sizeWidth.medium || sizeWidth.large)")
      //- LOADER PROCESS
      v-dialog(v-model="loader" persistent width="300")
        v-card(color="primary" dark="")
          v-card-text
            | {{ loaderTxt }}
            v-progress-linear.mb-0(indeterminate="" color="white")
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Links from '../interfaces/links'

export default {
  props: ['policy', 'productName', 'producto', 'subProducto'],
  mounted () {
    let innerWidth = window.innerWidth
    if (innerWidth > 1900) {
      this.sizeWidth.large = true
      this.sizeWidth.medium = false
    } else if (innerWidth <= 1900 && innerWidth > 600) {
      this.sizeWidth.large = false
      this.sizeWidth.medium = true
    }
    if (this.policy !== '') {
      if (this.basicInfo.correo !== null || this.basicInfo.celular !== null) {
        this.$amplitude.getInstance().logEvent('MDB - Inicio de Solicitud', {'Número Póliza': this.policy})
        this.txtEmail = this.basicInfo.correo
        if (this.basicInfo.correo !== null) {
          var arrEmail = this.basicInfo.correo.split('@')
          var nFirstCharEmail = arrEmail[0].slice(0, 3)
          var nLastCharEmail = arrEmail[0].slice(-2)
          this.emailEncript = nFirstCharEmail + '****' + nLastCharEmail + '@' + arrEmail[1]
        }
        if (this.basicInfo.celular !== null) {
          this.celularEncript = '*****' + this.basicInfo.celular.substring(5, this.basicInfo.celular.length)
        }
        // this.modalInit = true
        // this.$swal({
        //   title: '¡Recuerda!',
        //   html: 'Si no encuentras el parentesco en el listado de beneficiarios, por favor comunícate <a href="' + Links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
        //   confirmButtonText: 'Entendido'
        // })
        this.getBenefits({ numeroPoliza: this.policy })
          .then((res) => {
            let countPrincipal = 1
            let countContigente = 1
            let beneficiarios = res.data
            for (let index = 0; index < beneficiarios.length; index++) {
              let beneficiario = beneficiarios[index]
              if (beneficiario.tipoBeneficiario === 'PRINCIPAL') {
                let dateOrigin = beneficiario.fechaNacimiento
                let arrDateOrigin = dateOrigin.split('T')
                let arrNewFormatDate = arrDateOrigin[0].split('-')
                let newFormatDate = arrNewFormatDate[0] + '-' + arrNewFormatDate[1] + '-' + arrNewFormatDate[2]
                let synonymsParentesco = beneficiario.parentesco === 'HIJO' ? 'Hijo(a)' : beneficiario.parentesco.charAt(0).toUpperCase() + beneficiario.parentesco.slice(1).toLowerCase()
                let beneficiarioPrincipal = {
                  id: countPrincipal,
                  name: beneficiario.nombre,
                  paternal_surname: beneficiario.apellidoPaterno,
                  maternal_surname: beneficiario.apellidoMaterno,
                  number_document: beneficiario.numeroDocumento,
                  parent: synonymsParentesco,
                  distribution: parseInt(beneficiario.porcentajeDistribucion),
                  date_of_birth: newFormatDate,
                  nameProcess: '',
                  status: true,
                  show: false,
                  modal: false
                }
                this.listBeneficiariosPri.push(beneficiarioPrincipal)
                countPrincipal++
              } else if (beneficiario.tipoBeneficiario === 'CONTINGENTE') {
                let dateOrigin = beneficiario.fechaNacimiento
                let arrDateOrigin = dateOrigin.split('T')
                let arrNewFormatDate = arrDateOrigin[0].split('-')
                let newFormatDate = arrNewFormatDate[2] + '-' + arrNewFormatDate[1] + '-' + arrNewFormatDate[0]
                let synonymsParentesco = beneficiario.parentesco === 'HIJO' ? 'Hijo(a)' : beneficiario.parentesco.charAt(0).toUpperCase() + beneficiario.parentesco.slice(1).toLowerCase()
                let beneficiarioContigente = {
                  id: countContigente,
                  name: beneficiario.nombre,
                  paternal_surname: beneficiario.apellidoPaterno,
                  maternal_surname: beneficiario.apellidoMaterno,
                  number_document: beneficiario.numeroDocumento,
                  parent: synonymsParentesco,
                  distribution: parseInt(beneficiario.porcentajeDistribucion),
                  date_of_birth: newFormatDate,
                  nameProcess: '',
                  status: true,
                  show: false,
                  modal: false
                }
                this.listBeneficiariosCont.push(beneficiarioContigente)
                countContigente++
              }
            }
            // -- Clonando para detectar cambios (Es ambiguo esto, pero aprobaron esto en el funcional... Ridiculamente)
            this.deepCloneBenefPri = JSON.parse(JSON.stringify(this.listBeneficiariosPri))
            this.deepCloneBenefCont = JSON.parse(JSON.stringify(this.listBeneficiariosCont))
          })
          .catch((err) => { console.log('ERR: ', err) })
      } else {
        this.$swal({
          title: '¡Lo sentimos!',
          text: 'No puedes realizar el cambio de beneficiario, ya que no encontramos tu celular y/o correo registrado. Por favor, actualiza tus datos antes de continuar.',
          confirmButtonText: 'Ok'
        }).then((result) => {
          this.$amplitude.getInstance().logEvent('MDB - Actualizar Datos', {'Número Póliza': this.policy})
          this.$router.push('/')
        })
      }
    }
  },
  computed: {
    ...mapGetters('user', ['basicInfo']),
    listBeneficiariosPrincipal () {
      const list = this.listBeneficiariosPri.filter(item => item.status === true)
      return list
    },
    listBeneficiariosContingentes () {
      const list = this.listBeneficiariosCont.filter(item => item.status === true)
      return list
    }
  },
  data: () => ({
    links: Links,
    now: new Date().toLocaleDateString(),
    celularEncript: null,
    emailEncript: null,
    activeCircle1: true,
    activeCircle2: false,
    activeCircle3: false,
    step2HeaderText: true,
    step2HeaderCheck: false,
    step3HeaderText: true,
    step3HeaderCheck: false,
    icons: {
      iconPencil: require('./../assets/cvc/icon_pencil_login.svg')
    },
    listParent: [
      {
        text: 'Cónyuge'
      },
      {
        text: 'Hermano'
      },
      {
        text: 'Hijo(a)'
      },
      {
        text: 'Madre'
      },
      {
        text: 'Padre'
      },
      {
        text: 'Sobrino'
      },
      {
        text: 'Sobrina'
      },
    ],
    tooltips: {
      distribution: false,
      mainBenef: false,
      secondaryBenef: false,
      declaracion: false
    },
    modal: {
      dateBirth: false
    },
    listBeneficiariosPri: [],
    listBeneficiariosCont: [],
    deepCloneBenefPri: [],
    deepCloneBenefCont: [],
    onboarding: 1,
    txtEmail: '',
    step1: true,
    step2: false,
    step3: false,
    code: null,
    code2: null,
    code3: null,
    code4: null,
    code5: null,
    checkBeforeContinue: false,
    textValidation: '',
    objBenefit: null,
    idBenefit: null,
    typeBenefit: null,
    modalErrorCode: false,
    modalValidacion: false,
    modalSave: false,
    modalDelete: false,
    // modalInit: false,
    modalProcede: false,
    inputJurada: false,
    showTxtEmail: false,
    step3Part1: true,
    step3Part2: false,
    stepFinish: false,
    activeStep3Email: false,
    activeStep3Phone: false,
    loader: false,
    loaderTxt: null,
    sizeWidth: {
      large: false,
      medium: true
    },
  }),
  methods: {
    ...mapActions('user', ['getBenefits', 'sendDataToRequirements']),
    ...mapActions('requirements', ['sendCodeValidation', 'validateCodeValidation']),
    ...mapActions('endorsements', [
      'makeEndorsement',                // ← ORIGINAL: Para el flujo antiguo de dos pasos
      'makeEndorsementRequirement'      // ← NUEVO: Para el flujo unificado (como cambio de frecuencia)
    ]),
    addBenefitPrincipal () {
      if (this.listBeneficiariosPri.length < 10) {
        this.listBeneficiariosPri.push({
          name: '',
          paternal_surname: '',
          maternal_surname: '',
          number_document: '',
          parent: '',
          distribution: '',
          date_of_birth: '',
          nameProcess: 'Nuevo beneficiario',
          status: true,
          show: true,
          modal: false
        })
      }
    },
    addBenefitContingentes () {
      if (this.listBeneficiariosCont.length < 2) {
        this.listBeneficiariosCont.push({
          name: '',
          paternal_surname: '',
          maternal_surname: '',
          number_document: '',
          parent: '',
          distribution: '',
          date_of_birth: '',
          nameProcess: 'Nuevo beneficiario',
          status: true,
          show: true,
          modal: false
        })
      }
    },
    showTooltip (type) {
      switch (type) {
      case 'mainBenef':
        this.tooltips.mainBenef = true
        break
      case 'secondaryBenef':
        this.tooltips.secondaryBenef = true
        break
      case 'distribution':
        this.tooltips.distribution = true
        break
      case 'declaracion':
        this.tooltips.declaracion = true
        break
      default:
        break
      }
    },
    validateCode (evt, pos) {
      let charCode = (evt.which) ? evt.which : evt.keyCode
      switch (pos) {
      case 1:
        if (this.code !== null && this.code !== '') { this.$refs.code2.focus() }
        break
      case 2:
        if (charCode === 8) {
          this.$refs.code.focus()
        } else if (this.code2 !== null && this.code2 !== '') {
          this.$refs.code3.focus()
        }
        break
      case 3:
        if (charCode === 8) {
          this.$refs.code2.focus()
        } else if (this.code3 !== null && this.code3 !== '') {
          this.$refs.code4.focus()
        }
        break
      case 4:
        if (charCode === 8) {
          this.$refs.code3.focus()
        } else if (this.code4 !== null && this.code4 !== '') {
          this.$refs.code5.focus()
        }
        break
      case 5:
        if (charCode === 8) {
          this.$refs.code4.focus()
        }
        break
      }
    },
    closeModalDelete () {
      this.modalDelete = false
      this.typeBenefit = null
      this.idBenefit = null
    },
    closeModalSave () {
      this.modalSave = false
      this.typeBenefit = null
      this.idBenefit = null
    },
    checkEmail () {
      this.activeStep3Email = true
      this.activeStep3Phone = false
    },
    checkPhone () {
      this.activeStep3Phone = true
      this.activeStep3Email = false
    },
    deleteBenefit () {
      if (this.typeBenefit === 'principal') {
        // this.listBeneficiariosPri.splice(this.idBenefit, 1)
        this.listBeneficiariosPri[this.idBenefit].nameProcess = 'Eliminado'
        this.listBeneficiariosPri[this.idBenefit].status = false
        this.listBeneficiariosPri[this.idBenefit].show = false
      } else {
        // this.listBeneficiariosCont.splice(this.idBenefit, 1)
        this.listBeneficiariosCont[this.idBenefit].nameProcess = 'Eliminado'
        this.listBeneficiariosCont[this.idBenefit].status = false
        this.listBeneficiariosCont[this.idBenefit].show = false
      }
      this.closeModalDelete()
    },
    disableParent (parent) {
      return !(!parent || !!this.listParent.find(item => item.text === parent))
    },
    optionOtherParent(beneficiario) {
      if (beneficiario.parent === 'Otro') {
        this.$swal({
          title: '¡Recuerda!',
          html: 'Si no encuentras el parentesco en el listado de beneficiarios, por favor comunícate <a href="' + Links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
          confirmButtonText: 'Entendido'
        })

        beneficiario.parent = '';
        return;
      }
    },
    saveBenefit () {
      this.objBenefit.show = false
      let dniChangedOrAdded = this.objBenefit.number_document
      let dniFoundPri = this.deepCloneBenefPri.filter((el) => { return el.number_document === dniChangedOrAdded })
      let dniFoundCont = this.deepCloneBenefCont.filter((el) => { return el.number_document === dniChangedOrAdded })
      if (dniFoundPri.length > 0 || dniFoundCont.length > 0) {
        let dniFoundElement = null
        dniFoundElement = dniFoundPri.length > 0 ? dniFoundPri[0] : dniFoundCont[0]
        if (this.objBenefit.name !== dniFoundElement.name ||
            this.objBenefit.paternal_surname !== dniFoundElement.paternal_surname ||
            this.objBenefit.maternal_surname !== dniFoundElement.maternal_surname ||
            this.objBenefit.parent !== dniFoundElement.parent ||
            this.objBenefit.distribution !== dniFoundElement.distribution ||
            this.objBenefit.date_of_birth !== dniFoundElement.date_of_birth) {
          this.objBenefit.nameProcess = 'Actualizado'
        } else {
          // SI TODO ESTA IGUAL, TAL Y COMO LLEGÓ DESDE LA CONSULTA AL API, PUES NO HIZO NADA SOBRE EL BENEFICIARIO
          this.objBenefit.nameProcess = ''
        }
      } else {
        // SI MODIFICAN TODO O PARTE DEL DNI QUE ES LA PK, SE CONSIDERA COMO UN NUEVO BENEFICIARIO
        this.objBenefit.nameProcess = 'Nuevo beneficiario'
      }
      this.closeModalSave()
    },
    openModalDelete (item, itemId, itemType) {
      this.idBenefit = itemId
      this.typeBenefit = itemType
      this.modalDelete = true
    },
    openModalSave (item, itemId, itemType) {
      let sumDistribution = 0;
      let sumDistributionC = 0;
      let arr = []
      let arrDnis = []
      // PARA GUARDAR, DEBE COMPLETAR TODOS LOS DATOS
      if (item.name !== '' && item.paternal_surname && item.maternal_surname !== '' && item.number_document !== '' && item.parent !== '' && item.distribution !== '' && item.date_of_birth !== '') {
        // VERIFICAMOS SI LAS DISTRIBUCIONES SUMA 100% CORRECTAMENTE
        if (itemType === 'principal') {
          let beneficiariosActivos = this.listBeneficiariosPri.filter(f => { return f.nameProcess !== 'Eliminado' })
          // -- Obteniendo %s para verificar si suman 100
          arr = beneficiariosActivos.map((el) => { return parseInt(el.distribution) })
          sumDistribution = arr.reduce((a, b) => a + b, 0)
        } else if (itemType === 'contingente') {
          let beneficiariosActivos = this.listBeneficiariosCont.filter(f => { return f.nameProcess !== 'Eliminado' })
          // -- Obteniendo %s para verificar si suman 100
          arr = beneficiariosActivos.map((el) => { return parseInt(el.distribution) })
          sumDistributionC = arr.reduce((a, b) => a + b, 0)
        }
        // -- Obteniendo DNIs de Beneficiarios Principales
        let arrDnisPri = this.listBeneficiariosPri.filter(f => { return f.nameProcess !== 'Eliminado' }).map((el) => { return el.number_document })
        // -- Obteniendo DNIs de Beneficiarios Contingentes
        let arrDnisCont = this.listBeneficiariosCont.filter(f => { return f.nameProcess !== 'Eliminado' }).map((el) => { return el.number_document })
        // -- Juntamos todos los DNIs
        arrDnis = arrDnisPri.concat(arrDnisCont)
        // -- DNIs DUPLICADOS NO DEBE EXISTIR
        let existDuplicateDnis = (new Set(arrDnis)).size !== arrDnis.length
        // - SIN ZEROS O MENORES A ZEROS O NaNs
        let arrlessThanOrEqualZero = arr.filter(f => { return f <= 0 })
        if (arrlessThanOrEqualZero.length > 0) {
          this.textValidation = 'La sumatoria de todos tus beneficiarios principales tiene que ser del 100%.'
          this.modalValidacion = true
        } else if (sumDistributionC > 100 || isNaN(sumDistributionC)) {
          this.textValidation = 'La sumatoria de todos tus beneficiarios contingentes tiene que ser del 100%.'
          this.modalValidacion = true
        } else if (existDuplicateDnis) {
          this.textValidation = 'No puedes repetir el DNI mas de 1 vez.'
          this.modalValidacion = true
        } else {
          // SI TODO BIEN, SE GUARDAR EL BENEFICIARIO
          this.objBenefit = item
          this.idBenefit = itemId
          this.typeBenefit = itemType
          this.modalSave = true
        }
      } else {
        this.textValidation = 'Debes completar todos los datos para poder guardar el beneficiario correctamente'
        this.modalValidacion = true
      }
    },
    enableOpenStep2 () {
      if (this.inputJurada) {
        let aux = false
        for (let i = 0; i < this.listBeneficiariosPrincipal.length; i++) {
          aux = aux || this.listBeneficiariosPrincipal[i].show
        }
        for (let i = 0; i < this.listBeneficiariosContingentes.length; i++) {
          aux = aux || this.listBeneficiariosContingentes[i].show
        }
        return !aux
      }
      return true
    },
    openStep2 () {
      // -- VERIFICAMOS SI HA HECHO ALGO O NO SOBRE LOS BENEFICIARIOS
      let benefPri = this.listBeneficiariosPri.filter(f => { return f.nameProcess === '' })
      let benefCont = this.listBeneficiariosCont.filter(f => { return f.nameProcess === '' })
      const benefPriToSum = this.listBeneficiariosPri.filter(f => { return f.nameProcess !== 'Eliminado' })
      const sumBenefPri = benefPriToSum.map((el) => { return parseInt(el.distribution) }).reduce((a, b) => a + b, 0)
      const benefContToSum = this.listBeneficiariosCont.filter(f => { return f.nameProcess !== 'Eliminado' })
      const sumBenefCont = benefContToSum.map((el) => { return parseInt(el.distribution) }).reduce((a, b) => a + b, 0)
      if (!this.inputJurada) {
        this.textValidation = 'Debe aceptar la declaracion jurada.'
        this.modalValidacion = true
      } else if (!this.enableOpenStep2()) {
        this.textValidation = 'No puede continuar. Tienes datos sin guardar.'
        this.modalValidacion = true
      } else if (benefPri.length === this.listBeneficiariosPri.length && benefCont.length === this.listBeneficiariosCont.length) {
        this.textValidation = 'No hemos detectado ninguna modificación sobre tus beneficiarios. Por favor, verifica bien la solicitud antes de continuar.'
        this.modalValidacion = true
      } else if (sumBenefPri !== 100) {
        this.textValidation = 'La sumatoria de todos tus beneficiarios principales tiene que ser del 100%.'
        this.modalValidacion = true
      } else if (sumBenefCont !== 100 && benefContToSum.length > 0) {
        this.textValidation = 'La sumatoria de todos tus beneficiarios contingentes tiene que ser del 100%.'
        this.modalValidacion = true
      } else {
        // -- VERIFICAR SI ACEPTO LA DECLARACIÓN JURADA
        if (this.inputJurada) {
          this.activeCircle2 = true
          this.step2HeaderText = false
          this.step2HeaderCheck = true
          this.step1 = false
          this.step2 = true
          this.$amplitude.getInstance()
            .logEvent(
              'MDB - Vista de Confirmación',
              {
                'Número Póliza': this.policy,
                'Beneficiarios Principales': benefPri.map(b => {
                  return {
                    nombre: b.name + ' ' + b.paternal_surname + ' ' + b.maternal_surname,
                    documento: b.number_document,
                    parentesco: b.parent,
                    distribucion: b.distribution,
                    accion: b.nameProcess
                  }
                }),
                'Beneficiarios Contingentes': benefCont.map(b => {
                  return {
                    nombre: b.name + ' ' + b.paternal_surname + ' ' + b.maternal_surname,
                    documento: b.number_document,
                    parentesco: b.parent,
                    distribucion: b.distribution,
                    accion: b.nameProcess
                  }
                })
              }
            )
        }
      }
    },
    openStep3 () {
      if (!this.checkBeforeContinue) {
        this.modalProcede = true
      } else {
        this.goToStep3()
      }
    },
    goToStep3 () {
      this.modalProcede = false
      if (this.checkBeforeContinue) {
        this.activeCircle3 = true
        this.step3HeaderText = false
        this.step3HeaderCheck = true
        this.step2 = false
        this.step3 = true
        this.$amplitude.getInstance().logEvent('MDB - Confirmación de Solicitud', {'Número Póliza': this.policy})
      } else {
        this.checkBeforeContinue = true
      }
    },
    openStep3Part1 () {
      const self = this
      let opt = ''
      let metodoEnvio = ''
      if (this.activeStep3Email) {
        opt = '1'
        metodoEnvio = 'email'
      } else if (this.activeStep3Phone) {
        opt = '2'
        metodoEnvio = 'celular'
      }
      if (this.activeStep3Email || this.activeStep3Phone) {
        this.loader = true
        this.loaderTxt = 'Enviando código de validación...'
        let hash = {
          numeroDocumento: this.basicInfo.numeroDocumento,
          numeroPoliza: this.policy,
          metodoEnvio: opt
        }
        this.sendCodeValidation(hash)
          .then((res) => {
            self.$amplitude.getInstance()
              .logEvent(
                'MDB - Envio de código',
                {
                  'Estado': 'Exitoso',
                  'Número Poliza': self.policy,
                  'Método Envío': metodoEnvio
                }
              )
            self.loader = false
            self.step3Part1 = false
            self.step3Part2 = true
          })
          .catch((err) => {
            // console.log(err)
            self.$amplitude.getInstance()
              .logEvent(
                'MDB - Envio de código',
                {
                  'Estado': 'Error',
                  'Número Póliza': self.policy,
                  'Método Envío': metodoEnvio,
                  'Detalle': err
                }
              )
            self.loader = false
            self.$swal({
              title: '¡Oops, algo salió mal!',
              text: 'Utiliza otro método de validación o inténtalo nuevamente en unos minutos.',
              imageUrl: require('@/assets/characters/oops.svg'),
              confirmButtonText: 'Ok'
            })
          })
      }
    },
    openFinish () {
      const self = this
      if (this.code && this.code2 && this.code3 && this.code4 && this.code5) {
        let hash = {
          numeroDocumento: this.basicInfo.numeroDocumento,
          clave: this.code + this.code2 + this.code3 + this.code4 + this.code5
        }
        this.loader = true
        this.loaderTxt = 'Verificando código ingresado...'
        // -- PREPARANDO JSON PARA EL SERVICIO UNIFICADO (REQUERIMIENTO + ENDOSO)
        console.log('📋 DATOS DE ENTRADA - Modificación de Beneficiarios')
        console.log('Policy:', this.policy)
        console.log('ProductName:', this.productName)
        console.log('BasicInfo:', this.basicInfo)
        let requestEndoso = this.makeRequirementForAcsele()
        // -- HACIENDO LLAMADOS CORRESPONDIENTES AL SERVICIO UNIFICADO.
        // -- Desde validando el codigo ingresado, hasta el envio usando el servicio unificado de requerimiento + endoso.
        this.validateCodeValidation(hash)
          .then((resCode) => {
            self.loaderTxt = 'Registrando solicitud. Por favor, espere un momento, estamos procesando su solicitud...'
            self.$amplitude.getInstance()
              .logEvent(
                'MDB - Código Validado',
                {
                  'Estado': 'Exitoso',
                  'Número Póliza': this.policy
                }
              )
            /* ========================================
             * CÓDIGO ANTIGUO (COMENTADO) - FLUJO DE DOS PASOS
             * ========================================
             * PROBLEMA: Generaba error código 98 "requerimientos pendientes"
             * porque había validación intermedia entre los dos llamados
             * 
             * // PASO 1: Preparar form para requerimientos
             * let form = {
             *   'transact': 'Modificación de Beneficiarios',
             *   'name': this.basicInfo.nombres,
             *   'state': 'PENDIENTE',
             *   'product': this.productName,
             *   'policy': this.policy,
             *   'home_address': 'No aplica',
             *   'department': 'No aplica',
             *   'province': 'No aplica',
             *   'district': 'No aplica',
             *   'paternal_surname': this.basicInfo.apellidoPaterno,
             *   'maternal_surname': this.basicInfo.apellidoMaterno !== '' ? this.basicInfo.apellidoMaterno : '-',
             *   'type_document': this.basicInfo.tipoDocumento,
             *   'number_document': this.basicInfo.numeroDocumento,
             *   'cellphone': this.basicInfo.celular,
             *   'phone': 'No aplica',
             *   'email': this.basicInfo.correo
             * }
             *
             * // PASO 2: Preparar hashForApiTraductor para endoso (solo endoso)
             * let hashForApiTraductor = this.makeRequirementForAcsele() // ← Solo devolvía ENDOSO + dynamicData
             *
             * // FLUJO SEPARADO PROBLEMÁTICO:
             * self.sendDataToRequirements(form)  // ← PRIMER llamado
             *   .then((resReq) => {
             *     self.makeEndorsement(hashForApiTraductor)  // ← SEGUNDO llamado (aquí fallaba)
             *       .then((resEndorsement) => {
             *         // Éxito
             *       })
             *       .catch((errEndorse) => {
             *         // Error código 98: requerimientos pendientes
             *       })
             *   })
             *   .catch((errReq) => {
             *     // Error en requerimientos
             *   })
             * 
             * ======================================== */

            // CÓDIGO NUEVO - SERVICIO UNIFICADO (Mismo flujo que cambio de frecuencia)
            // SOLUCIÓN: Un solo llamado que maneja requerimiento + endoso simultáneamente
            console.log('🚀 REQUEST ENVIADO - Modificación de Beneficiarios:', requestEndoso)
            self.makeEndorsementRequirement(requestEndoso)
              .then((response) => {
                console.log('✅ RESPONSE RECIBIDO - Modificación de Beneficiarios:', response)
                if (response.data) {
                  console.log('📊 CÓDIGO DE RESPUESTA:', response.data.codigoRespuesta)
                  console.log('📊 MENSAJE:', response.data.mensajeRespuesta || response.data.responseMessage)
                }
                // Manejo específico por código de respuesta
                switch(response.data ? response.data.codigoRespuesta : null) {
                  case '01':
                    // Éxito - El backend ya registró el requerimiento y generó el endoso
                    self.loader = false
                    self.step3Part1 = false
                    self.step3Part2 = false
                    self.step3 = false
                    self.stepFinish = true
                    self.$amplitude.getInstance()
                      .logEvent(
                        'MDB - Requerimiento Enviado',
                        {
                          'Estado': 'Exitoso',
                          'Número Póliza': this.policy
                        }
                      )
                    setTimeout(() => {
                      self.$root.$emit('showNps', {
                        nombre: 'NPS - Inicio de Encuesta',
                        funcionalidad: 'Solicitud Modificación de Beneficiarios',
                        metadata: {
                          numeroPoliza: self.policy,
                          productoConsultado: self.producto,
                          subproductoConsultado: self.subProducto
                        }
                      })
                    }, 3000)
                    break;
                  case '98':
                    // Error: requerimientos pendientes
                    self.loader = false
                    self.$swal({
                      title: 'Atención',
                      html: 'No puedes modificar los beneficiarios de tu póliza porque ya cuentas con una solicitud pendiente. Por favor, vuelve a intentarlo con otra póliza o comunícate <a href="' + Links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
                      confirmButtonText: 'Entendido'
                    })
                    self.$amplitude.getInstance()
                      .logEvent(
                        'MDB - Requerimiento Enviado',
                        {
                          'Estado': 'Error - Requerimiento Pendiente',
                          'Número Póliza': this.policy,
                          'Código': '98'
                        }
                      )
                    break;
                  default:
                    // Error genérico o respuesta sin código reconocido
                    console.log('⚠️ CÓDIGO DE RESPUESTA NO RECONOCIDO:', response.data ? response.data.codigoRespuesta : 'Sin código')
                    self.loader = false
                    self.$amplitude.getInstance()
                      .logEvent(
                        'MDB - Requerimiento Enviado',
                        {
                          'Estado': 'Error',
                          'Número Póliza': this.policy,
                          'Detalle': response.data || response
                        }
                      )
                    self.$swal({
                      title: '¡Oops, algo salió mal!',
                      html: 'Inténtalo más tarde o comunícate <a href="' + Links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
                      imageUrl: require('@/assets/characters/oops.svg'),
                      imageHeight: 180,
                      imageWidth: 180,
                      confirmButtonText: 'Entendido'
                    })
                    break;
                }
              })
              .catch((errEndorse) => {
                console.log('❌ ERROR EN REQUEST - Modificación de Beneficiarios:', errEndorse)
                self.loader = false
                self.$amplitude.getInstance()
                  .logEvent(
                    'MDB - Requerimiento Enviado',
                    {
                      'Estado': 'Error',
                      'Número Póliza': this.policy,
                      'Detalle': errEndorse.data
                    }
                  )
                self.$swal({
                  title: '¡Oops, algo salió mal!',
                  html: 'Inténtalo más tarde o comunícate <a href="' + Links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
                  imageUrl: require('@/assets/characters/oops.svg'),
                  imageHeight: 180,
                  imageWidth: 180,
                  confirmButtonText: 'Entendido'
                })
              })
            // FIN DEL CÓDIGO NUEVO - Servicio unificado funcionando correctamente
          })
          .catch((errCode) => {
            console.log('❌ ERROR EN VALIDACIÓN DE CÓDIGO:', errCode)
            self.$amplitude.getInstance()
              .logEvent(
                'MDB - Código Validado',
                {
                  'Estado': 'Error',
                  'Detalle': errCode,
                  'Número Póliza': this.policy
                }
              )
            self.loader = false
            if (errCode.data && errCode.data.codigoRespuesta === '99' && errCode.data.mensajeRespuesta === 'La Clave no es correcta') {
              self.modalErrorCode = true
            }
          })
      }
    },
    backToStep1 () {
      this.activeCircle2 = false
      this.step2HeaderText = true
      this.step2HeaderCheck = false
      this.step1 = true
      this.step2 = false
    },
    goToHome () {
      var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')
      for (var i = 0; i < allElements.length; i++) {
        allElements[i].classList.remove('active-menu')
      }
      var el = allElements[0] // HOME
      el.classList.add('active-menu')
      // FOR AVOID ERROR IN REDUDANT PATH
      if (this.$route.path !== '/') { this.$router.push('/') }
    },
    goToProfile () {
      var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')
      for (var i = 0; i < allElements.length; i++) {
        allElements[i].classList.remove('active-menu')
      }
      var el = allElements[1] // MI PERFIL
      el.classList.add('active-menu')
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          'Funcionalidad Seleccionada',
          {
            'Funcionalidad': 'Mis Datos'
          }
        )
      // FOR AVOID ERROR IN REDUDANT PATH
      if (this.$route.path !== '/mi-perfil') { this.$router.push('/mi-perfil') }
    },
    changeRequirement () {
      if (this.$route.path !== '/solicitudes') { this.$router.push('/solicitudes') }
    },
    makeRequirementForAcsele () {
      let benefPri = this.listBeneficiariosPri.filter(f => { return f.nameProcess !== 'Eliminado' })
      let benefCont = this.listBeneficiariosCont.filter(f => { return f.nameProcess !== 'Eliminado' })
      /**
       * MAKE BODY OF JSON
      */
      let dynamicBenefPri = []
      for (let index = 0; index < 10; index++) {
        let order = index + 1
        let greekNumber = this.romanize(order)
        let benef = benefPri[index]
        // TRANSFORMANDO EL SINONIMO-PARENTESCO AL CORRECTO
        if (benef !== undefined && benef.parent === 'Hijo(a)') {
          benef.parent = 'Hijo'
        }
        // Cada campo es independiente. No es un objeto con todos los campos incluidos
        // -- Apellido Paterno
        let apePaternoCont = {
          etiqueta: 'ApePaternoBen' + greekNumber,
          value: benef !== undefined ? benef.paternal_surname : ''
        }
        dynamicBenefPri.push(apePaternoCont)
        // -- Apellido Materno
        let apeMaternoCont = {
          etiqueta: 'ApeMaternoBen' + greekNumber,
          value: benef !== undefined ? benef.maternal_surname : ''
        }
        dynamicBenefPri.push(apeMaternoCont)
        // -- Nombres
        let nombresCont = {
          etiqueta: 'NombresBen' + greekNumber,
          value: benef !== undefined ? benef.name : ''
        }
        dynamicBenefPri.push(nombresCont)
        // -- Fecha de nacimiento
        let fechaNacCont = {
          etiqueta: 'FechaNacBen' + greekNumber,
          value: benef !== undefined ? benef.date_of_birth : ''
        }
        dynamicBenefPri.push(fechaNacCont)
        // -- Numero de documento
        let docIdentCont = {
          etiqueta: 'DocIdentidadBen' + greekNumber,
          value: benef !== undefined ? benef.number_document : ''
        }
        dynamicBenefPri.push(docIdentCont)
        // -- Parentesco
        let parentescoCont = {
          etiqueta: 'ParentescoBen' + greekNumber,
          value: benef !== undefined ? benef.parent : ''
        }
        dynamicBenefPri.push(parentescoCont)
        // -- Distribución
        let distribucionCont = {
          etiqueta: 'DistribucionBen' + greekNumber,
          value: benef !== undefined ? parseInt(benef.distribution).toString() : ''
        }
        dynamicBenefPri.push(distribucionCont)
      }
      let dynamicBenefCont = []
      for (let jindex = 0; jindex < 3; jindex++) {
        let order = jindex + 1
        let greekNumber = this.romanize(order)
        let benef = benefCont[jindex]
        // TRANSFORMANDO EL SINONIMO-PARENTESCO AL CORRECTO
        if (benef !== undefined && benef.parent === 'Hijo(a)') {
          benef.parent = 'Hijo'
        }
        // Cada campo es independiente. No es un objeto con todos los campos incluidos
        // -- Apellido Paterno
        let apePaternoCont = {
          etiqueta: 'ApePaternoBenC' + greekNumber,
          value: benef !== undefined ? benef.paternal_surname : ''
        }
        dynamicBenefCont.push(apePaternoCont)
        // -- Apellido Materno
        let apeMaternoCont = {
          etiqueta: 'ApeMaternoBenC' + greekNumber,
          value: benef !== undefined ? benef.maternal_surname : ''
        }
        dynamicBenefCont.push(apeMaternoCont)
        // -- Nombres
        let nombresCont = {
          etiqueta: 'NombresBenC' + greekNumber,
          value: benef !== undefined ? benef.name : ''
        }
        dynamicBenefCont.push(nombresCont)
        // -- Fecha de nacimiento
        let fechaNacCont = {
          etiqueta: 'FechaNacBenC' + greekNumber,
          value: benef !== undefined ? benef.date_of_birth : ''
        }
        dynamicBenefCont.push(fechaNacCont)
        // -- Numero de documento
        let docIdentCont = {
          etiqueta: 'DocIdentidadBenC' + greekNumber,
          value: benef !== undefined ? benef.number_document : ''
        }
        dynamicBenefCont.push(docIdentCont)
        // -- Parentesco
        let parentescoCont = {
          etiqueta: 'ParentescoBenC' + greekNumber,
          value: benef !== undefined ? benef.parent : ''
        }
        dynamicBenefCont.push(parentescoCont)
        // -- Distribución
        let distribucionCont = {
          etiqueta: 'DistribucionBenC' + greekNumber,
          value: benef !== undefined ? parseInt(benef.distribution).toString() : ''
        }
        dynamicBenefCont.push(distribucionCont)
      }
      let dynamicDataArr = dynamicBenefPri.concat(dynamicBenefCont)
      /**
       * MAKE HEADER OF JSON
       */
      let today = new Date()
      let currentDate = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + (today.getDate())).slice(-2)
      let endosoHeader = {
        idProducto: '',
        PlanVida: '',
        interesado: 'digital',
        policyNumber: this.policy,
        FechaSolicitud: currentDate,
        ResponsableAtencion: 'SAC',
        TipoEndoso: 'Endoso Simple',
        InicioVigenciaEndoso: '',
        TipoVigenciaEndoso: '',
        Endoso: 'CambioBeneficiario',
        FechaMovimiento: currentDate,
        FechaCliente: currentDate,
        FechaEfectiva: currentDate
      }
      
      /* ========================================
       * CÓDIGO ANTIGUO (COMENTADO) - Solo devolvía endoso
       * ========================================
       * let hashEndoso = {
       *   ENDOSO: endosoHeader,
       *   dynamicData: dynamicDataArr  // ← Solo datos de beneficiarios
       * }
       * ======================================== */

      // CÓDIGO NUEVO - Estructura unificada para servicio que maneja requerimiento + endoso
      let hashEndoso = {
        transact: 'Modificación de Beneficiarios',  // ← NUEVO: Identificador de transacción
        ENDOSO: endosoHeader,                       // ← ORIGINAL: Header del endoso
        dynamicData: dynamicDataArr,                // ← ORIGINAL: Datos de beneficiarios
        // ↓ NUEVO: Datos del formulario organizados en formData (requerimiento)
        formData: {
          transact: 'Modificación de Beneficiarios',
          name: this.basicInfo.nombres,
          state: 'PENDIENTE',
          product: this.productName,
          policy: this.policy,
          home_address: 'No aplica',
          department: 'No aplica',
          province: 'No aplica',
          district: 'No aplica',
          paternal_surname: this.basicInfo.apellidoPaterno,
          maternal_surname: this.basicInfo.apellidoMaterno !== '' ? this.basicInfo.apellidoMaterno : '-',
          type_document: this.basicInfo.tipoDocumento,
          number_document: this.basicInfo.numeroDocumento,
          cellphone: this.basicInfo.celular,
          phone: 'No aplica',
          email: this.basicInfo.correo,
          response_medium: 'Electrónico',
          origen: 'ZONASEGURA'
        }
      }
      return hashEndoso
    },
    viewBeneficiario (item) {
      item.show = !item.show
    },
    viewBeneficiarioOnResumen (item) {
      item.show = !item.show
    },
    verifyChars (evt) {
      this.possibilities = false
      let charCode = (evt.which) ? evt.which : evt.keyCode
      if (!(/^[0-9]*$/).test(evt.key) && charCode !== 8) {
        evt.preventDefault()
      }
    },
    saveDateBirthBenef (type, item, idx) {
      if (type === 'principal') {
        this.$refs['mainDialogDateBirth' + idx][0].save(item.date_of_birth)
      } else {
        this.$refs['secondDialogDateBirth' + idx][0].save(item.date_of_birth)
      }
    },
    romanize (num) {
      if (isNaN(num)) { return NaN }
      const digits = String(+num).split('')
      const key = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM',
        '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC',
        '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX']
      let roman = ''
      let i = 3
      while (i--) { roman = (key[+digits.pop() + (i * 10)] || '') + roman }
      return Array(+digits.join('') + 1).join('M') + roman
    }
  }
}
</script>
<style>
  .beneficiarios {
    padding-bottom: 2em;
  }
  .beneficiarios svg,
  .beneficiarios .v-text-field .v-input__control .v-input__slot .v-text-field__slot label svg {
    cursor: pointer;
  }
  .beneficiarios .v-text-field .v-input__control .v-input__slot .v-text-field__slot label {
    width: 100%;
    pointer-events: all;
  }
  .beneficiarios .v-text-field .v-input__control .v-input__slot .v-text-field__slot label svg {
    position: relative;
    top: 2px;
    left: 5px;
  }
  .beneficiarios-steps-header .layout {
    justify-content: space-between;
    margin: 0 auto 20px auto;
    max-width: 242px;
  }
  .beneficiarios-steps-header .circle {
    align-items: center;
    border:2px solid rgba(201, 201, 201, 1);
    border-radius: 50%;
    display: flex;
    height: 30px;
    justify-content: center;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    width: 30px;
  }
  .circle-active .circle {
    background: rgb(8, 85, 196)!important;
    border: 2px solid rgb(8, 85, 196)!important;
  }
  .circle-active .circle::before {
      background: rgb(8, 85, 196);
  }
  .circle-active i {
    color: white!important;
  }
  .circle-active p,
  .circle-active strong {
      color: rgb(8, 85, 196);
  }
  .circle-line::before{
    background: rgba(201, 201, 201, 1);
    content:'';
    height: 2px;
    top: 50%;
    left:28px;
    transition: all 0.3s;
    transform: translateY(-50%);
    position: absolute;
    width: 56px;
  }
  .beneficiarios-steps-header .circle p {
    color: #C9C9C9;
    font-weight: bold;
    margin-bottom: 0;
    transition: all 0.3s;
  }
  .beneficiarios-steps-header strong {
    display: block;
    font-size: 14px;
    margin-top: 10px;
    transition: all 0.3s;
  }
  .beneficiarios-steps-header .circle i {
    color:rgb(8, 85, 196);
    font-weight: bold;
    font-size: 1.2rem;
    transition: all 0.3s;
  }
  /** DETALLE PRODUCTO SELECCIONADO */
  #product-detail .myproduct {
    border: solid 1px #E7EAED;
    border-radius: 3px;
  }
  #product-detail .myproduct .mp-title {
    color: #0855C4;
    padding: 10px 15px;
    text-align: left;
    border-bottom: 1px solid #E7EAED;
  }
  #product-detail .myproduct .row-mp-subtitle {
    margin: 10px 15px 30px 15px;
  }
  #product-detail .myproduct .row-mp-subtitle .col-mp-button {
    text-align: right;
  }
  #product-detail .myproduct .row-mp-subtitle button {
    background-color: #0855C4;
    padding: 0.3em 1em;
    color: #FFFFFF;
    border-radius: 4px;
    font-size: 12px;
  }
  #product-detail .myproduct .row-mp-data.hr {
    border-bottom: 1px solid #E7EAED;
    margin: 10px 15px;
    padding-bottom: 10px;
  }
  #product-detail .myproduct .row-mp-data.hr.last {
    border-bottom: 0;
    padding-bottom: 0;
  }
  #product-detail .myproduct .row-mp-data.hr p {
    margin-bottom: 0;
  }
  #product-detail .myproduct .mp-data-name {
    text-align: left;
  }
  #product-detail .myproduct .mp-data-value {
    text-align: left;
    font-weight: bold;
  }

  .beneficiarios-step-1-list article{
    margin-top: 15px;
  }

  .beneficiarios-step-1-list .btns{
    display: flex;
    justify-content: space-between;
    gap: 25px;
  }

  .beneficiarios-step-1-list .btns button{
    border-radius: 5.48936px;
    font-size: 15px;
    height: 45px;
    outline: none;
    margin-top: 20px;
    width: 100%;
  }

  .beneficiarios-step-1-list .btns .g-btn-delete{
    border: 1px solid var(--fuchsia-color);
    color: var(--fuchsia-color);
  }

  .beneficiarios-step-1-list .btns .g-btn-save{
    background: var(--second-brand-color);
    color:  white;
  }
  /** MODIFICACIONES DEL UI */
  .beneficiarios-step-1-section,
  .beneficiarios-step-1-email,
  .beneficiarios-step-1-politicas,
  .beneficiarios-step-1-jurada,
  .beneficiarios-btn,
  .beneficiarios-step-2 .mb-5,
  .beneficiarios-step-2-descrip,
  .beneficiarios-step-2-list,
  .beneficiarios-step-1-title p {
    padding: 0 15%;
  }
  .beneficiarios-steps-header-item.circle-active {
    background-color: transparent !important;
  }
  .modal.modal-tooltip {
    padding-bottom: 25px;
    padding-top: 25px;
    width: 365px;
  }
  .modal .close-modal-custom {
    position: absolute;
    top: 1%;
    right: 4%;
    font-size: 27px;
    cursor: pointer;
  }
  /** RESPONSIVE */
  /* Small to large handset ----------- */
  @media only screen and (max-width : 600px) {
    .beneficiarios { padding-bottom: 0; }
    #product-detail { display: none; }
    .beneficiarios-step-1-section,
    .beneficiarios-step-1-email,
    .beneficiarios-step-1-politicas,
    .beneficiarios-step-1-jurada,
    .beneficiarios-btn,
    .beneficiarios-step-2 .mb-5,
    .beneficiarios-step-2-descrip,
    .beneficiarios-step-2-list,
    .beneficiarios-step-1-title p {
      padding: 0;
    }
  }

  @media only screen and (min-width : 1024px) {

  }
</style>



// WEBPACK FOOTER //
// src/pages/ProfileBenefits.vue